/** @format */

import * as React from "react";
import {
  Flex,
  Link,
  Image,
  Text,
  useMediaQuery,
  Stack
} from "@chakra-ui/react";
import { commonInfo } from "@common/en";
import theme from "@src/style/theme";
import colors from "@src/style/colors";
import DOMPurify from "dompurify";

export const Download_KR: React.FC = () => {
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const sanitizer = DOMPurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };
  return (
    <Flex
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      textAlign={"center"}
      bgGradient="linear(to-tl,#01F6FF 
        , #007BFF)"
      paddingX={basePaddingX}
      paddingY={basePaddingY}>
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignItems={"center"}>
        <Text
          wordBreak={"keep-all"}
          fontSize={{
            base: "16px",
            sm: "24px",
            md: "32px",
            lg: "50px"
          }}
          fontWeight={"700"}
          color={colors.white}
          dangerouslySetInnerHTML={{
            __html: sanitizer(commonInfo.appDownload.title)
          }}
        />
        <Flex
          mt={{ base: "20px", sm: "32px", md: "20px", lg: "36px" }}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={{ base: "1vw", sm: "1vw", md: "2vw", lg: "2vw" }}>
          <Link
            width={{ base: "150px", sm: "150px", md: "180px", lg: "230px" }}
            href={commonInfo.appDownload.items[1].url}
            isExternal>
            <Image src={`${commonInfo.appDownload.items[1].image}`} />
          </Link>
          <Link
            width={{ base: "150px", sm: "150px", md: "180px", lg: "230px" }}
            href={commonInfo.appDownload.items[0].url}
            isExternal>
            <Image src={`${commonInfo.appDownload.items[0].image}`} />
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Download_KR;
